import { React, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppIcons from "../../../assets/images/icons";

import { ScrollToTopOnMount } from "../../../Components/ScrollToTop/ScrollToTop";
import "./blogs.scss";

// import S3ImageViewerWithFallback from '../../../Components/awsS3ImageViewer/ImgViewerWithFallback';
import { Grid } from '@mui/material';
import BlogInsta from '../../../Components/blogRevamp/blogInsta';
import BlogListSlider from '../../../Components/blogRevamp/blogListSlider';
import { showSnackbar } from "../../../Components/Notification/Snackbar";
import ApiCaller from "../../../services/api/APICaller";
import S3ImageViewerWithFallback from "../../../Components/awsS3ImageViewer/ImgViewerWithFallback";
import PdfDownloaderWithFallback from "../../../Components/awsS3pdfDownloader/PdfDownloaderWithFallback";
// import DownloadBrochurePopup from '../../../Components/downloadBrochurePopup/downloadBrochurePopup';

const Blogs = () => {
  ScrollToTopOnMount();




  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  /**
  the legendary use effect function
  This will run very first on render
   */
  useEffect(() => {
    getDataArr();
  }, [])

  const getDataArr = () => {
    const apiCaller = new ApiCaller('pdf-reports/our-reports');
    apiCaller.getList().then(({ data }) => {
      setData(data.result)
    })
      .catch(() => showSnackbar().failure('Something went wrong'))
      .finally(() => setIsLoading(false));
  }



  return (
    <div className="page-main-wrapper about-main-wrapper-1 article-main-wrapper article-revamp-wrapper article-reUI f-wrp">

      <div className="article-banner-wrp f-wrp">
        <div className="container">
          <Grid container spacing={1.5}>
            <Grid item xs={9} sm={8} md={8} lg={6}>
              <div className="banner-content-box f-wrp">
                <h1 className="main-title">Insights</h1>
                <p>Explore expert guides, market reports, videos, and more—all designed to help you understand Dubai’s real estate market and invest with confidence.</p>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>

      <div className='insight-content-box f-wrp'>

        <div className='each-insight-sections f-wrp'>
          <div className='container'>
            <div className='insight-section-header f-wrp'>
              <h1 className='main-title'>Real Estate in 60 Seconds</h1>
              <p className='pc-title'>Stay sharp with bite-sized insights into Dubai’s real estate scene.</p>
              <p className='Mob-title' style={{ display: 'none' }}>Tips, Guides & Trends</p>
            </div>


            <BlogInsta />

            <br />
            <br />


            <div className='insight-section-header f-wrp'>
              <h1 className='main-title'>Blog Posts</h1>
              <p>What's trending, what's worth it, and how to get ahead — all in one place.</p>
            </div>
            <div className='blogListSlider f-wrp'>
              <BlogListSlider />
            </div>

            <br />
            <br />




          </div>


        </div>


        <div className='each-insight-sections f-wrp'>
          <div className='container'>
            <div className='insight-section-header f-wrp' style={{ maxWidth: '660px', display: 'flex', flexDirection: 'column', margin: '0 auto', float: 'none' }}>
              <h1 className='main-title'>In-Depth PDF Reports</h1>
              <p>From ROI trends to top locations—download our in-depth PDF reports to get serious about investing in Dubai.</p>
            </div>
          </div>
        </div>
        
        {(isLoading) ? "Loading PDF Reports" :
          <>
            {(!isLoading && data?.length === 0) ? "No Results found" :

              <>
                {data?.map((element, key) => (element.isBGImgLayout ? (
                  <div className='each-insight-sections download-brochure-section f-wrp' key={key}>
                    <span className="bg-img"><S3ImageViewerWithFallback fileKey={element.imageURL} /></span>
                    <div className='container'>
                      <div className='download-brochure-box'>
                        <div className="download-content-box f-wrp">
                          <h1 className="main-title">{element.title}</h1>
                          <p>{element.description}</p>
                          {element?.attachmentURL ? <PdfDownloaderWithFallback fileTitle={element.title} fileKey={element?.attachmentURL} /> : null}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='each-insight-sections f-wrp' key={key}>
                    <div className='container'>
                      <div className='pdf-download-section'>
                        <Grid container spacing={1.5}>
                          <Grid item xs={12} sm={12} md={12} lg={7}>
                            <div className="download-content-box f-wrp">
                              <h1 className="main-title">{element.title}</h1>
                              <p>{element.description}</p>
                              {element?.attachmentURL ? <PdfDownloaderWithFallback fileTitle={element.title} fileKey={element?.attachmentURL} /> : null}
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} lg={5}>
                            <div className="download-side-img f-wrp">
                              <span><S3ImageViewerWithFallback fileKey={element.imageURL} /></span>
                            </div>
                          </Grid>
                        </Grid>

                      </div>
                    </div>
                  </div>
                )
                ))}
              </>
            }
          </>
        }








        <div className='each-insight-sections f-wrp' style={{ display: 'none' }}>
          <div className='container'>
            <div className='pdf-download-section'>
              <Grid container spacing={1.5}>
                <Grid item xs={12} sm={12} md={12} lg={7}>
                  <div className="download-content-box f-wrp">
                    <h1 className="main-title">Dubai's Investment Map</h1>
                    <p>Discover where smart money is moving. This exclusive PDF maps out Dubai’s top-performing investment zones — with ROI data to back it up, average price per square foot, and insights into where high-net-worth buyers are looking next.</p>
                    {/* <a className='pdf-download-btn' href="/files/my-document.pdf" download style={{ textDecoration: 'none' }}>
                      Download Brochure
                    </a> */}

                    {/* <DownloadBrochurePopup title={'Download Brochure'} brochureName={"Dubai's next millionaire"} brochureLink={"/Dubai's next millionaire_compressed.pdf"} /> */}

                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={5}>
                  <div className="download-side-img f-wrp">
                    <span><img src={AppIcons.freeDownload} alt='download pdf' /></span>
                  </div>
                </Grid>
              </Grid>

            </div>
          </div>
        </div>

        <div className='each-insight-sections download-brochure-section f-wrp' style={{ display: 'none' }}>
          <div className='container'>
            <div className='download-brochure-box'>


              <div className="download-content-box f-wrp">
                <h1 className="main-title">Dubai’s Next Millionaire</h1>
                <p>Dubai’s next wave of millionaires isn’t guessing — they’re investing differently.<br />
                  This insider PDF reveals the locations, tactics, and timing they’re using to stay ahead of the curve — and why missing this could mean missing out on Dubai’s most lucrative opportunities.</p>
                {/* <a className='pdf-download-btn' href="../" download style={{ textDecoration: 'none' }}>
                  Download Brochure
                </a> */}
                {/* <DownloadBrochurePopup title={'Download Brochure'} brochureName={"DUBAI INVESTMENT MAP"} brochureLink={"/DUBAI INVESTMENT MAP.pdf"} /> */}
              </div>


            </div>
          </div>
        </div>







        <div className='agent-required-wrp f-wrp'>
          <div className='container'>
            <div className='agent-required-box f-wrp'>
              <div className='img-blk'>
                <span>
                  <img src={AppIcons.Sarah} alt='Sarah' />
                </span>
              </div>
              <div className='content-sec'>
                <div className='content-box'>
                  <h1>Become our Agent.</h1>
                  <p>Become a sales agent with us and unlock exciting opportunities in real estate while learning from the best team in the industry!</p>
                </div>
                {/* <button className='reg-btn'>Register Now</button> */}
                <Link to={'/register'} className='reg-btn'>Register Now</Link>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Blogs;
